import { FaAward } from "react-icons/fa";
import { TbBooks } from "react-icons/tb";
import { BiHappyHeartEyes } from "react-icons/bi";

const data = [
  { aboutId: 1, icon: <FaAward />, title: "Stack Technique", desc: "VMware, Linux Debian, Windows Server" },
  { aboutId: 2, icon: <TbBooks />, title: "Automatisation", desc: "Powershell, Ansible, Bash" },
  {
    aboutId: 3,
    icon: <BiHappyHeartEyes />,
    title: "Disponibilité",
    desc: "Alternance septembre 2026",
  },
];

export default data;
